import {SelectTrigger} from '@/components/ui/select-atoms/SelectAtoms'
import styled, {css} from 'styled-components'

export const StyledSelectTrigger = styled(SelectTrigger)(
    () => css`
        padding: 0;
        outline: none;
        box-shadow: none;

        &:hover:not(:disabled),
        &:focus,
        &[aria-expanded='true'] {
            outline: none;
            box-shadow: none;
        }
    `
)
